import { Box } from "@mui/material"
import React from "react"

type TabPanelProps = {
  children?: React.ReactNode
  index: number
  value: number
}

export const TabPanel = (props: TabPanelProps) => {
  const { children, value, index } = props
  return (
    <Box role="tabpanel" hidden={value !== index} id={`tabpanel-${index}`}>
      {value === index && children}
    </Box>
  )
}
